//Styles
import "./App.css";

// Component
import ToDoWindow from "./ToDoWindow";

//Context
import { IsDoneContext } from "./Context/IsDoneContext";
import { ToDoListContext } from "./Context/ToDoListContext";

//Hooks
import { useEffect, useState } from "react";

//Others
import { createTheme, ThemeProvider } from "@mui/material";

// Fonts & Thems
const them = createTheme({
  typography: {
    fontFamily: ["Alexandria"],
  },
});

const initialTasks = [
  {
    id: 1,
    title: "دراسة مفاهيم React",
    subTitle: "مراجعة الـ Context API و Hooks وتطبيقها في المشروع",
    isDone: true,
  },
  {
    id: 2,
    title: "شراء مستلزمات المنزل",
    subTitle: "قهوة، حليب، خضروات",
    isDone: false,
  },
  {
    id: 3,
    title: "تجهيز أوراق السفر",
    subTitle: "",
    isDone: false,
  },
  {
    id: 4,
    title: "دفع فواتير شهر 3",
    subTitle: "دفع فاتورة الكهرباء والإنترنت عبر التطبيق البنكي",
    isDone: true,
  },
  {
    id: 5,
    title: "تصميم واجهة المستخدم",
    subTitle: "استخدام Adobe Illustrator لتجهيز الأيقونات الجديدة للموقع",
    isDone: false,
  },
];

function App() {
  const [filter, setFilter] = useState("all");
  const [tasks, setTasks] = useState(initialTasks);
  useEffect(() => {
    const storgeTasks = JSON.parse(localStorage.getItem("tasks"));
    setTasks(storgeTasks || initialTasks);
  }, []);
  return (
    <ThemeProvider theme={them}>
      <ToDoListContext.Provider value={{ tasks, setTasks }}>
        <IsDoneContext.Provider value={{ filter, setFilter }}>
          <div
            className="App"
            dir="rtl"
            style={{
              padding: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ToDoWindow />
          </div>
        </IsDoneContext.Provider>
      </ToDoListContext.Provider>
    </ThemeProvider>
  );
}

export default App;
